export default __webpack_public_path__ + "static/media/sebastian-herrmann-Vk8NI43e3HM-unsplash.5fb233e2.jpg";